import { render } from "./AppSettingTable.vue?vue&type=template&id=9640b3dc&scoped=true"
import script from "./AppSettingTable.vue?vue&type=script&lang=js"
export * from "./AppSettingTable.vue?vue&type=script&lang=js"

import "./AppSettingTable.vue?vue&type=style&index=0&id=9640b3dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9640b3dc"]])

export default __exports__